import { BlogCard } from "../../entities/Blog";
import { useGetPostsQuery } from "../../entities/Blog/api/blogApi";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { Container, Title, Button } from "../../shared/ui";

import styles from "./BlogsPage.module.scss";
import { FC, useState } from "react";

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm);

const DEFAULT_VISIBLE_DESKTOP_ARTICLES = 10;
const DEFAULT_VISIBLE_MOBILE_ARTICLES = 7;
const MORE_ARTICLES_COUNT = 4;
const NEWS_COUNT_TO_TAKE = 20;

export const BlogsPage: FC = () => {
    const isMobile = useMediaQuery(mediaQuery);

    const defaultVisible = isMobile ? DEFAULT_VISIBLE_MOBILE_ARTICLES : DEFAULT_VISIBLE_DESKTOP_ARTICLES;

    const [visible, setVisible] = useState(defaultVisible);

    const { data: news } = useGetPostsQuery({ take: NEWS_COUNT_TO_TAKE });

    const hasMoreNews = visible < (news?.length ?? 0);

    const handleShowMoreCard = () => {
        setVisible((prevValue) => prevValue + MORE_ARTICLES_COUNT);
    };

    return (
        <Container marginSize="standard" className={styles.blogsPage}>
            <div className={styles.blogsPage__titleWrapper}>
                <Title className={styles.blogsPage__title} level={1}>
                    Новости о&nbsp;нас
                </Title>
            </div>
            <div className={styles.blogsPage__news_main}>
                {news
                    ?.slice(0, 2)
                    .map((item) => <BlogCard className={styles.blogsPage__card_main} key={item.id} {...item} />)}
            </div>
            <div className={styles.blogsPage__news}>
                {news
                    ?.slice(2, visible)
                    .map((item) => <BlogCard className={styles.blogsPage__card} key={item.id} {...item} />)}
            </div>

            {hasMoreNews && (
                <Button as="button" className={styles.blogsPage__buttonLink} onClick={handleShowMoreCard}>
                    Показать больше новостей
                </Button>
            )}
        </Container>
    );
};
